"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegendTableBody = void 0;
const react_1 = __importDefault(require("react"));
const legend_table_item_1 = require("./legend_table_item");
const LegendTableBody = ({ items, ...itemProps }) => {
    return (react_1.default.createElement("div", { role: "rowgroup", className: "echLegendTable__rowgroup" }, items.map((item) => (react_1.default.createElement(legend_table_item_1.LegendListItem, { key: `${item.seriesIdentifiers[0].key}`, item: item, ...itemProps })))));
};
exports.LegendTableBody = LegendTableBody;
//# sourceMappingURL=legend_table_body.js.map